export default __webpack_public_path__ + "static/image15-61f72955b836d75d56d1eb33819ee479.gif";